import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import homeImage from "../assets/images/home.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  BlogGetListNews,
  setBlogGetListNewsData,
} from "../services/ReduxTookit/Slice/BlogRedux";
import Loader, { LoaderType } from "./common-component/Loader";
import calendar from "../assets/images/calendar.svg";
import { commonservices } from "../services/CommonServices";

const Announcement = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [loader, setLoader] = useState();
  const NewsDataList = useSelector(
    (state) => state?.blogredux?.BlogGetListNewsData?.data?.data?.data
  );

  const GetNewsData = () => {
    setLoader(true);
    dispatch(
      BlogGetListNews({
        latestnewsid: location?.state?.id,
        pagesize: 1,
        pagenumber: 1,
      })
    )?.then(() => {
      setLoader(false);
    });
  };

  useEffect(() => {
    GetNewsData();

    return () => {
      dispatch(setBlogGetListNewsData());
    };
  }, []);
  return (
    <div className="projects-page-main all-page-top">
      <Container>
        <div className="top-bot-section workflow-tab">
          <h6>
            <img
              src={homeImage}
              alt="home"
              title="home"
              style={{ cursor: "pointer", marginBottom: "3px" }}
              onClick={() => navigate("/")}
            />
            <span style={{ fontWeight: "400", color: "#666666" }}>{" | "}</span>
            <span className="mt-1">Announcement</span>
          </h6>
        </div>
        <Row>
          <Col xl={12} className="mt16">
            {/* <h4>Title: {NewsDataList && NewsDataList[0]?.title}</h4> */}
            <p
              //   dangerouslySetInnerHTML={NewsDataList[0]?.detaildescription}
              dangerouslySetInnerHTML={{
                __html: NewsDataList && NewsDataList[0]?.detaildescription,
              }}
            ></p>
            {/* <div className="common-white-bg h-100">
              <div className="chart-title mb12">
                <h5>Latest Announcements</h5>
              </div>
              <div className="all-annoncements">
                {loader ? (
                  <Loader type={LoaderType.AllAnnouncements} />
                ) : (
                  NewsDataList?.map((item, index) => {
                    return (
                      <div className="single-announcement" key={index}>
                        <h3>{item?.title}</h3>
                        <p>{item?.shortdescription}</p>
                        <div className="d-flex align-items-center gap-1">
                          <img
                            src={calendar}
                            alt="calendar"
                            className="xsm-icons"
                          />
                          <span>
                            {item?.dateofpublished &&
                              commonservices.convertDateToLocal(
                                item?.dateofpublished
                              )}
                          </span>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Announcement;
